import { render, staticRenderFns } from "./SlotListItem.vue?vue&type=template&id=52d87088&"
import script from "./SlotListItem.vue?vue&type=script&lang=js&"
export * from "./SlotListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports